module.exports = __webpack_public_path__ + "static/img/124_phase_function_Paper_PointsHejduk_Prediction.384d779.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/124_phase_function_Paper_PointsHejduk_Prediction.png
// module id = pxel
// module chunks = 0